import { render, staticRenderFns } from "./SindhMapOverall.vue?vue&type=template&id=1c59d6a5&scoped=true&"
import script from "./SindhMapOverall.vue?vue&type=script&lang=js&"
export * from "./SindhMapOverall.vue?vue&type=script&lang=js&"
import style0 from "./SindhMapOverall.vue?vue&type=style&index=0&id=1c59d6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c59d6a5",
  null
  
)

export default component.exports